import { useEffect, useState } from "react";
import { MailWarning } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

export function EmailPauseBanner() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/integrations/email-status").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d?.paused) return null;
  return (
    <div className="border-b border-red-400 bg-red-600 px-5 py-2 text-sm font-semibold text-white" role="alert" data-testid="email-paused-banner">
      <MailWarning size={16} className="mr-1 inline" aria-hidden="true" />
      Email sending PAUSED – no email is sent and no connection is made to the mail server. {d.reason ? `(${d.reason})` : ""}
    </div>
  );
}

export function EmailPauseControl({ onChanged }) {
  const [s, setS] = useState(null);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/integrations/smtp/pause").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const act = async (path, body) => {
    setBusy(true);
    try { const r = await api.post(`/admin/integrations/smtp/${path}`, body); setS(r.data); setTyped(""); toast.success(r.data.paused ? "Email sending paused" : "Email sending unpaused"); onChanged?.(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!s) return null;
  return (
    <div className={`space-y-2 rounded border p-3 text-sm ${s.paused ? "border-red-300 bg-red-50 text-red-900" : "border-slate-200"}`} data-testid="smtp-pause-control">
      <p className="font-semibold" data-testid="smtp-pause-state">{s.paused ? `Email sending PAUSED${s.reason ? `: ${s.reason}` : ""}` : "Email sending active"}</p>
      <p className="text-xs">Limits per server: {s.limits.per_hour} recipients/hour, {s.limits.per_day}/day, 20 s apart; login test at most once per 10 min. No automatic retries; held emails are never auto-resent.{s.preview_blocked ? " This server is a preview: it never connects to the real mail server." : ""}</p>
      {s.paused && !s.by_env && (
        <div className="flex flex-wrap items-end gap-2">
          <div><label htmlFor="smtp-unpause-input" className="field-label">Type UNPAUSE to resume sending</label>
            <input id="smtp-unpause-input" className="field-input" value={typed} onChange={(e) => setTyped(e.target.value)} data-testid="smtp-unpause-input" /></div>
          <button type="button" className="btn-outline" disabled={busy || typed !== "UNPAUSE"} onClick={() => act("unpause", { confirm: typed })} data-testid="smtp-unpause-btn">Unpause sending</button>
        </div>)}
      {s.by_env && <p className="text-xs">Paused by the server setting SMTP_PAUSED; remove it on the server to allow unpausing.</p>}
      {!s.paused && <button type="button" className="btn-outline" disabled={busy} onClick={() => act("pause")} data-testid="smtp-pause-btn">Pause sending now</button>}
    </div>
  );
}
